class CallAudioManager {
  constructor() {
    this.incoming = new Audio("/sounds/incoming.mp3");
    this.outgoing = new Audio("/sounds/outgoing.mp3");
    this.busy = new Audio("/sounds/busy.mp3");
    this.end = new Audio("/sounds/end.mp3");

    this.incoming.loop = true;
    this.outgoing.loop = true;
    this.busy.loop = false;
    this.end.loop = false;
  }

  playIncoming() {
    this.stopAll();
    this.incoming.currentTime = 0;
    this.incoming.play().catch(() => {});
  }

  playOutgoing() {
    this.stopAll();
    this.outgoing.currentTime = 0;
    this.outgoing.play().catch(() => {});
  }

  playBusy() {
    this.busy.currentTime = 0;
    this.busy.play().catch(() => {});
  }

   playEnd() {
    this.end.currentTime = 0;
    this.end.play().catch(() => {});
  }

  stopAll() {
    [this.incoming, this.outgoing, this.busy, this.end].forEach((a) => {
      a.pause();
      a.currentTime = 0;
    });
  }
}

export default new CallAudioManager(); // 🔥 singleton